import React from 'react';
import { useKeycloak } from '@react-keycloak/web';

const UserProfileBadge = () => {
  const { keycloak } = useKeycloak();

  const userName = keycloak?.tokenParsed?.name || 'User';
  const client =
    process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'api-service-client';
  const isNTSAUser =
    keycloak.tokenParsed?.resource_access?.[client]?.roles?.includes('ntsa');
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map((word: string) => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const userInitials = getInitials(userName);

  return (
    <div
      className={`flex items-center space-x-3 p-4 border-b
      ${isNTSAUser ? 'border-green-600 border-b-2 courier' : ''}`}
    >
      {isNTSAUser ? (
        <div
          className="w-12 h-12 rounded-full text-white 
          flex items-center justify-center text-lg font-semibold"
        >
          <img src="/ntsa-logo.svg" alt="ntsa logo" />
        </div>
      ) : (
        <div
          className="w-12 h-12 rounded-full bg-blue-500 text-white 
          flex items-center justify-center text-lg font-semibold"
        >
          {userInitials}
        </div>
      )}

      <div className="flex-1">
        <div className="font-semibold text-gray-800">{userName}</div>
      </div>
    </div>
  );
};

export default UserProfileBadge;
